import { BoosterUpdate, StkBooster, StkToolkitAccount } from '../types'

interface OptimisticUpdates {
  forDeletedBooster: (deletedBooster: StkBooster) => StkToolkitAccount[]
  forCreatedBooster: (newBooster: BoosterUpdate) => StkToolkitAccount[]
  forUpdatedBooster: (
    originalBooster: StkBooster,
    updatedBooster: Partial<StkBooster>,
  ) => StkToolkitAccount[]
}

export const optimisticallyUpdate = (
  toolkitAccounts: StkToolkitAccount[],
): OptimisticUpdates => {
  const forDeletedBooster = (
    deletedBooster: StkBooster,
  ): StkToolkitAccount[] => {
    const accountIds = deletedBooster.accounts.map(acct => acct.stkAccountId)
    const updatedAccounts = toolkitAccounts.map(acct => {
      if (accountIds.includes(acct.stkAccountId)) {
        return { ...acct, inUse: false }
      }
      return acct
    })
    return updatedAccounts
  }
  const forCreatedBooster = (
    newBooster: BoosterUpdate,
  ): StkToolkitAccount[] => {
    // istanbul ignore next optional chaining
    const accountIds = newBooster.accounts?.map(acct => acct.stkAccountId)
    // istanbul ignore next optional chaining
    const updatedAccounts = toolkitAccounts?.map(acct => {
      // istanbul ignore next optional chaining
      if (accountIds?.includes(acct.stkAccountId)) {
        return { ...acct, inUse: true }
      }
      return acct
    })
    return updatedAccounts
  }

  const forUpdatedBooster = (
    originalBooster: StkBooster,
    updatedBooster: Partial<StkBooster>,
  ): StkToolkitAccount[] => {
    // istanbul ignore next optional chaining
    const accountIdsToRemove = originalBooster?.accounts
      .filter(
        acct =>
          // istanbul ignore next optional chaining
          !updatedBooster?.accounts?.some(
            a => a.stkAccountId === acct.stkAccountId,
          ),
      )
      .map(ac => ac.stkAccountId)
    // istanbul ignore next optional chaining
    const accountIdsToAdd = updatedBooster?.accounts
      ?.filter(
        acct =>
          // istanbul ignore next optional chaining
          !originalBooster?.accounts.some(
            a => a.stkAccountId === acct.stkAccountId,
          ),
      )
      .map(ac => ac.stkAccountId)
    const updatedAccounts = toolkitAccounts.map(acct => {
      // istanbul ignore next optional chaining
      if (accountIdsToRemove?.includes(acct.stkAccountId)) {
        return { ...acct, inUse: false }
      }
      // istanbul ignore next optional chaining
      if (accountIdsToAdd?.includes(acct.stkAccountId)) {
        return { ...acct, inUse: true }
      }
      return acct
    })
    return updatedAccounts
  }

  return { forDeletedBooster, forCreatedBooster, forUpdatedBooster }
}
